import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import type { AppListing } from '@/backend/types';
import * as apps from '../api/apps';
import { strings } from '@/theme';
import { Chip, EmptyState, IdentityChip, Screen } from '../ui';

/** Ported from src/app/(main)/(tabs)/my-apps.tsx — the apps you have published or joined. */
export default function MyApps() {
  const navigate = useNavigate();
  const [myApps, setMyApps] = useState<AppListing[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let live = true;
    void apps
      .fetchMyApps()
      .then((list) => {
        if (live) setMyApps(list);
      })
      .catch(() => undefined)
      .finally(() => {
        if (live) setIsLoading(false);
      });
    return () => {
      live = false;
    };
  }, []);

  if (myApps.length === 0 && !isLoading) {
    return (
      <Screen title={strings.tabs.myApps}>
        <EmptyState
          icon="emptyApps"
          title="No apps yet"
          body="Apps you publish or join show up here."
          ctaTitle="Find one to try"
          onCta={() => navigate('/discover')}
        />
      </Screen>
    );
  }

  return (
    <Screen title={strings.tabs.myApps}>
      <ul className="project-list app-grid">
        {myApps.map((a) => (
          <li key={a.appId}>
            <button
              type="button"
              className="card clay-card pressable project-row"
              onClick={() => navigate(`/app/${a.appId}`)}
            >
              <IdentityChip name={a.name} />
              <span className="project-text">
                <span className="type-heading">{a.name}</span>
                {a.description && <span className="type-caption project-meta">{a.description}</span>}
              </span>
              {a.personal ? <Chip label="Yours" tone="primary" /> : <Chip label="Shared" tone="neutral" />}
            </button>
          </li>
        ))}
      </ul>
    </Screen>
  );
}
